<template>
    <div>
        <label>Width</label>
        <AppRadioButtonsGroup
            v-if="!pixelsOnly"
            label="label"
            trackBy="key"
            :value="selectedTypeKey"
            :options="Object.values(types)"
            @update="selectType"/>
        <vue-number-input
            v-if="selectedTypeKey !== types.auto.key"
            :value="parseInt(value)"
            @change="onChange"
            :min="minWidth"
            :max="maxWidth"
            controls
            class="mt-2"
            size="small">
        </vue-number-input>
    </div>
</template>

<script>
import AppRadioButtonsGroup from '../../../../../../../components/shared/AppRadioButtonsGroup'

export default {
    name: 'FieldWidthEditor',
    components: {AppRadioButtonsGroup},
    props: {
        value: {
            required: true
        },
        pixelsOnly: {
            type: Boolean,
            required: true,
            default: false
        }
    },
    data() {
        return {
            selectedTypeKey: null,
            types: {
                auto: {
                    key: 'auto',
                    label: 'Auto',
                    tooltip: 'Stretch to the size of the container'
                },
                percentage: {
                    key: 'percentage',
                    label: '%',
                    tooltip: '% of container width'
                },
                pixels: {
                    key: 'pixels',
                    label: 'Pixels',
                    tooltip: 'Fixed width in pixels'
                }
            }
        }
    },
    computed: {
        minWidth() {
            if (this.selectedTypeKey === this.types.percentage.key) {
                return 10
            }
            return 40
        },

        maxWidth() {
            if (this.selectedTypeKey === this.types.percentage.key) {
                return 100
            }
            return 1920
        }
    },
    methods: {
        onChange(width) {
            if (width === this.value) { // TODO: possible vue-number-input bug? (fired on load)
                return
            }
            if (this.selectedTypeKey === this.types.percentage.key) {
                width += '%'
            }
            this.$emit('update', width)
        },

        selectType(typeKey) {
            this.selectedTypeKey = typeKey
            this.onChange(this.selectedTypeKey === this.types.auto.key ? null : parseInt(this.value))
        }
    },
    created() {
        if (this.pixelsOnly) {
            this.selectedTypeKey = this.types.pixels.key
        } else {
            if (typeof this.value === 'string' && this.value.includes('%')) {
                this.selectedTypeKey = this.types.percentage.key
            } else if (!this.value || _.isNaN(parseInt(this.value))) {
                this.selectedTypeKey = this.types.auto.key
            } else if (this.pixelsOnly || _.isNumber(this.value)) {
                this.selectedTypeKey = this.types.pixels.key
            }
        }
    }
}
</script>

<style scoped lang="scss">
 button {
     width: 31px;
     background: #f0f0f5 !important;
     font-size: 16px;
     font-weight: 500;
     color: $color-black-soft;

     &:hover {
         color: $color-purple-light;
     }
 }

 .active-btn {
     font-weight: 600;
     color: $color-purple-light;
     background: #f0f0f5;
 }
</style>
